export const PRIZM_DIGIT_REGEXP = /\d/;
export const PRIZM_NON_DIGIT_REGEXP = /\D/;
export const PRIZM_NON_DIGITS_REGEXP = /\D+/g;
export const PRIZM_LEADING_ZEROES_REGEXP = /^0+/;
export const PRIZM_MASK_SYMBOLS_REGEXP = /[ \-_()]/g;
export const PRIZM_LAST_PUNCTUATION_MARK_REGEXP = /[.,\\/#!$%\\^&\\*;:{}=\\-_`~()]$/;
export const PRIZM_LATIN_REGEXP = /[A-z]/;
export const PRIZM_LATIN_AND_NUMBERS_REGEXP = /[A-z|0-9]/;
